/**
 *
 * ModalEditSurvey
 *
 */

import React, { Component } from "react"
import { Modal, Button, Select, Input, Popover, Radio, Space } from "antd"
import { map, isEqual } from "lodash"
import "./index.less"
import { isModuleBySlug } from "../../utils/storage"
import { SEGMENTS } from "../../utils/constants"
import questionIcon from "../../images/question.svg"
import { buttonAction_btns } from "../Snowplow/config2"

const { Option } = Select

class ModalEditSurvey extends Component {
  state = {
    id_survey_type: undefined,
    surveyName: undefined,
    id_scope_type: undefined,
    selectedSegments: [],
  }

  componentDidMount = () => {
    const { surveyName } = this.props
    const segments = map(surveyName.segments, (segment) => segment.id_segment)
    this.setState({
      surveyName: surveyName.name,
      id_survey_type: surveyName.id_survey_type,
      id_scope_type: surveyName.id_scope_type,
      selectedSegments: segments,
    })
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (!isEqual(prevProps.surveyName, this.props.surveyName)) {
      const { surveyName } = this.props
      const segments = map(surveyName.segments, (segment) => segment.id_segment)
      this.setState({
        surveyName: surveyName.name,
        id_survey_type: surveyName.id_survey_type,
        id_scope_type: surveyName.id_scope_type,
        selectedSegments: segments,
      })
    }
  }

  validate = () => {
    const {
      id_survey_type,
      id_scope_type,
      surveyName,
      selectedSegments,
    } = this.state

    if (surveyName === "" || surveyName === undefined) {
      return false
    }

    if (id_scope_type === 2) {
      if (selectedSegments.length === 0) {
        return false
      }
    }

    return true
  }

  render() {
    const isSegmentsEnabled = isModuleBySlug(SEGMENTS)
    const contentSegment = (
      <div style={{ maxWidth: 300, fontSize: 12, textAlign: "justify" }}>
        Especifica a qué segmentos de los creados en el Panel de Control
        aplicará este cuestionario. Luego, al agendar una medición, a los
        colaboradores les llegará el cuestionario asociado a su segmento, para
        el indicador en cuestión.
      </div>
    )
    return (
      <Modal
        className="modal-edit-survey-header"
        title="Editar cuestionario"
        style={{ top: 76 }}
        visible={this.props.visible}
        onCancel={() => this.props.setStateFrom("modalEditSurvey", false)}
        footer={[
          <Button
            key="back"
            onClick={() => {
              const { surveyName } = this.props

              this.setState({ surveyName: surveyName.name })
              this.props.setStateFrom("modalEditSurvey", false)
            }}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={!this.validate()}
            onClick={() => {
              const data = {
                idSurvey: this.props.idSurvey,
                params: {
                  name: this.state.surveyName,
                  id_survey_type: this.state.id_survey_type,
                  id_scope_type: this.state.id_scope_type,
                  segments: this.state.selectedSegments,
                },
              }

              this.props.updateSurveyWatcher(data)
              this.props.setStateFrom("modalEditSurvey", false)
              buttonAction_btns("Guardar editar cuestionario")
            }}>
            Guardar
          </Button>,
        ]}
        width={520}>
        <div>
          <p style={{ marginBottom: "4px" }}>
            <strong style={{ fontWeight: "600", fontSize: "14px" }}>
              Nombre del cuestionario*:
            </strong>
          </p>
          <Input
            value={this.state.surveyName}
            style={{ width: "100%", marginBottom: "16px", marginTop: "4px" }}
            maxLength={46}
            placeholder="Ejemplo: Clima laboral"
            onChange={(e) => this.setState({ surveyName: e.target.value })}
          />
          <p style={{ marginBottom: "4px" }}>
            <strong style={{ fontWeight: "600", fontSize: "14px" }}>
              Indicador a medir*:
            </strong>
          </p>
          <Popover
            placement="top"
            content={
              <div
                style={{ maxWidth: 300, fontSize: 12, textAlign: "justify" }}>
                No es posible modificar el indicador de un cuestionario.
              </div>
            }>
            <Select
              value={this.state.id_survey_type}
              style={{ width: "100%", marginBottom: "16px" }}
              // disabled={get(this.props.surveyName, 'template_based', false)}
              disabled
              placeholder="Seleccionar tipo"
              // onChange={e => this.setStateFrom('id_survey_type', e)}
            >
              {map(this.props.surveyTypes, (item, index) => {
                return (
                  <Option key={index} value={item.id_survey_type}>
                    {item.name}
                  </Option>
                )
              })}
            </Select>
          </Popover>
          {isSegmentsEnabled && (
            <>
              <div style={{ marginBottom: "4px" }}>
                <strong style={{ fontWeight: "600" }}>Alcance*:</strong>
                <Popover placement="top" content={contentSegment}>
                  <img src={questionIcon} style={{ marginLeft: 8 }} />
                </Popover>
              </div>
              {this.props.surveyName.measures_in_use_count > 0 ? (
                <Popover
                  placement="top"
                  content={
                    <div
                      style={{
                        maxWidth: 300,
                        fontSize: 12,
                        textAlign: "justify",
                      }}>
                      No es posible editar elementos de un cuestionario que está
                      siendo utilizado en una medición activa.
                    </div>
                  }>

                  <Radio.Group
                    disabled={true}
                    value={this.state.id_scope_type}
                    onChange={(e) =>
                      this.setState({ id_scope_type: e.target.value })
                    }>
                    <Space direction="vertical">
                      {map(this.props.scopeTypes, (item, index) => {
                        return (
                          <Radio value={item.id_scope_type}>{item.name}</Radio>
                        )
                      })}
                    </Space>
                  </Radio.Group>
                  {this.state.id_scope_type === 2 && (
                    <div>
                      <Select
                        disabled={
                          true
                        }
                        mode="tags"
                        allowClear
                        placeholder="Seleccionar segmentos"
                        maxTagCount={3}
                        maxTagTextLength={14}
                        style={{ marginTop: "12px", width: "100%" }}
                        value={this.state.selectedSegments}
                        onChange={(e) =>
                          this.setState({ selectedSegments: e })
                        }>
                        {this.props.segments.map((segment, index) => {
                          return (
                            <Option key={index} value={segment.id_segment}>
                              {segment.name}
                            </Option>
                          )
                        })}
                      </Select>
                    </div>
                  )}
                </Popover>
              ) : (
                <>

                  <Radio.Group
                    disabled={true}
                    value={this.state.id_scope_type}
                    onChange={(e) =>
                      this.setState({ id_scope_type: e.target.value })
                    }>
                    <Space direction="vertical">
                      {map(this.props.scopeTypes, (item, index) => {
                        return (
                          <Radio value={item.id_scope_type}>{item.name}</Radio>
                        )
                      })}
                    </Space>
                  </Radio.Group>
                  {this.state.id_scope_type === 2 && (
                    <div>
                      <Select
                        disabled={true}
                        mode="tags"
                        allowClear
                        placeholder="Seleccionar segmentos"
                        maxTagCount={3}
                        maxTagTextLength={14}
                        style={{ marginTop: "12px", width: "100%" }}
                        value={this.state.selectedSegments}
                        onChange={(e) =>
                          this.setState({ selectedSegments: e })
                        }>
                        {this.props.segments.map((segment, index) => {
                          return (
                            <Option key={index} value={segment.id_segment}>
                              {segment.name}
                            </Option>
                          )
                        })}
                      </Select>
                    </div>
                  )}{" "}
                </>
              )}
            </>
          )}
        </div>
      </Modal>
    )
  }
}

export default ModalEditSurvey
